import { useState } from 'react'

const useFallbackImage = (defaultImage: string, remoteImage: string | null) => {
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const [imageUrl, setImageUrl] = useState<string>(defaultImage)
  const [hasError, setHasError] = useState<boolean>(false)

  const handleImageLoaded = () => {
    // If remoteImage is null or there's an error, use the defaultImage.
    if (!remoteImage || hasError) {
      setImageUrl(defaultImage)
      setIsLoading(false)
    } else {
      setImageUrl(remoteImage)
      setIsLoading(false)
    }
  }

  const handleImageError = () => {
    if (!hasError) {
      setHasError(true)
      setImageUrl(defaultImage)
    }
  }

  return { imageUrl, handleImageLoaded, handleImageError, hasError, isLoading }
}

export default useFallbackImage
